import MainLayout from '../Layouts/MainLayout';
import 'bootstrap/dist/css/bootstrap.min.css';
import { motion } from 'framer-motion';
import { useState } from 'react';
import fondo_ser from "../assets/imagenes/fondo_servicios.jpg";
import { BiSolidReport } from "react-icons/bi";
import { TbReportAnalytics} from "react-icons/tb";
import { BsFillMegaphoneFill } from "react-icons/bs";
import { MdContactSupport, MdCloudUpload } from "react-icons/md";
import { PiListMagnifyingGlassBold } from "react-icons/pi";

const Servicios = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    asunto: '',
    mensaje: ''
  });

  const colors = {
    primary: '#1A6B77',
    secondary: '#FBAA2C',
    dark: '#1A1A1A',  
    light: '#FFFFFF',   
    gray: '#F4F4F4', 
    accent: '#E8F5F7'
};

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(prevStatus => ({ ...prevStatus, submitting: true }));

    const formDataToSend = new FormData();
    formDataToSend.append('access_key', process.env.REACT_APP_WEB3FORMS_KEY);
    formDataToSend.append('nombre', formData.nombre);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('asunto', formData.asunto);
    formDataToSend.append('mensaje', formData.mensaje);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataToSend
      });
      
      const data = await response.json();
      
      if (data.success) {
        setStatus({
          submitted: true,
          submitting: false,
          info: { error: false, msg: '¡Mensaje enviado exitosamente!' }
        });
        setFormData({
          nombre: '',
          email: '',
          asunto: '',
          mensaje: ''
        });
      } else {
        setStatus({
          submitted: false,
          submitting: false,
          info: { error: true, msg: 'Ocurrió un error al enviar el mensaje.' }
        });
      }
    } catch (error) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'Ocurrió un error al enviar el mensaje.' }
      });
    }
  };

    return (
        <MainLayout>
            <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="d-flex align-items-center position-relative"
            style={{
                backgroundImage: `url(${fondo_ser})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                color: '#fff'
            }}
            >
            <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}
            ></div>

            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className="row">
                <div className="col-md-6">
                    <h1 className="fw-bold display-4 mb-3">Servicios</h1>
                    <p className="lead">  
                    Explore los servicios que integran nuestra solución tecnológica, diseñados para eficiencia, seguridad y cumplimiento.
                    </p>
                    <a href="#detalle-servicios" className="btn btn-outline-light mt-4">
                    Ver Servicios
                    </a>
                </div>
                </div>
            </div>
            </motion.section>
            <motion.section
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="py-5 bg-white"
                aria-label="Sección de Servicios"
            >
                <div className="container">
                <div className="row justify-content-center mb-5 text-center">
                    <div className="col-md-8 col-lg-6">
                    <div className="mb-4">
                        <span
                        className="d-inline-block px-3 py-1 rounded-pill bg-opacity-10"
                        style={{
                            backgroundColor: colors.secondary,
                            color: '#FFFFFF',
                            fontSize: '0.9rem',
                            fontWeight: 600
                        }}
                        >
                        Productos
                        </span>
                    </div>
                    <h2
                        className="fw-bold mb-3"
                        style={{
                        color: '#1A1A1A',
                        fontSize: '2.2rem',
                        position: 'relative',
                        display: 'inline-block'
                        }}
                    >
                        Nuestros Servicios
                    </h2>
                    <p className="lead text-muted">
                        Solucion integral para el monitoreo y promoción de la salud laboral, diseñadas para potenciar el bienestar de tus colaboradores.
                    </p>
                    <div
                        style={{
                        height: '4px',
                        width: '80px',
                        backgroundColor: colors.secondary,
                        margin: '15px auto',
                        borderRadius: '2px'
                        }}
                    />
                    </div>
                </div>
    
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    {[
                    {
                        icon: <BsFillMegaphoneFill size={50} style={{ color: colors.primary }} />,
                        title: 'Evaluaciones de Salud',
                        description: 'Evaluaciones médicas periódicas y exámenes especializados para detectar riesgos laborales y prevenir enfermedades ocupacionales.',
                        bgColor: 'rgba(26, 107, 119, 0.05)',
                        borderColor: 'rgba(26, 107, 119, 0.1)'
                    },
                    {
                        icon: <TbReportAnalytics size={50} style={{ color: colors.primary }} />,
                        title: 'Reportes Inteligentes',
                        description: 'Dashboard interactivo con métricas clave, tendencias y alertas tempranas para una gestión basada en datos.',
                        bgColor: 'rgba(26, 107, 119, 0.05)',
                        borderColor: 'rgba(26, 107, 119, 0.1)'
                    },
                    {
                        icon: <MdContactSupport size={50} style={{ color: colors.primary }} />,
                        title: 'Soporte 24/7',
                        description: 'Equipo multidisciplinario disponible para resolver dudas, emergencias y acompañar la implementación de programas de salud.',
                        bgColor: 'rgba(26, 107, 119, 0.05)',
                        borderColor: 'rgba(26, 107, 119, 0.1)'
                    },
                    {
                        icon: <PiListMagnifyingGlassBold size={50} style={{ color: colors.primary }} />,
                        title: 'Asesorías Estratégicas',
                        description: 'Planes personalizados de bienestar laboral, alineados a los objetivos y cultura organizacional de tu empresa.',
                        bgColor: 'rgba(26, 107, 119, 0.05)',
                        borderColor: 'rgba(26, 107, 119, 0.1)'
                    },
                    {
                        icon: <MdCloudUpload size={50} style={{ color: colors.primary }} />,
                        title: 'Plataforma Tecnológica',
                        description: 'Sistema en la nube para monitoreo en tiempo real, integración con wearables y gestión centralizada de la salud ocupacional.',
                        bgColor: 'rgba(26, 107, 119, 0.05)',
                        borderColor: 'rgba(26, 107, 119, 0.1)'
                    },
                    {
                        icon: <BiSolidReport size={50} style={{ color: colors.primary }} />,
                        title: 'Programas de Intervención',
                        description: 'Acciones correctivas y preventivas basadas en evidencia, desde talleres hasta campañas de concientización.',
                        bgColor: 'rgba(26, 107, 119, 0.05)',
                        borderColor: 'rgba(26, 107, 119, 0.1)'
                    },
                    ].map((service, index) => (
                    <motion.div
                        key={index}
                        whileHover={{ y: -5, transition: { duration: 0.3 } }}
                        className="col"
                    >
                        <div
                        className="card h-100 border-0 rounded-4 p-4 text-center shadow-sm"
                        style={{
                            backgroundColor: service.bgColor,
                            borderTop: `3px solid ${service.borderColor}`,
                            transition: 'all 0.3s ease'
                        }}
                        >
                        <div className="mb-4" style={{ color: colors.primary }}>
                            {service.icon}
                        </div>
                        <h4
                            className="fw-semibold mb-3"
                            style={{ color: colors.dark }}
                        >
                            {service.title}
                        </h4>
                        <p className="text-muted mb-0" style={{ lineHeight: '1.6' }}>
                            {service.description}
                        </p>
                        </div>
                    </motion.div>
                    ))}
                </div>
                </div>
            </motion.section>
            <motion.section
            id = 'Contactanos'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            style={{
                background: colors.accent,
                padding: '120px 0 80px',
                position: 'relative',
                overflow: 'hidden'
            }}
            >
            <motion.div
                style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: colors.light,
                zIndex: 1
                }}
            />
            
            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        style={{
                            background: colors.light,
                            borderRadius: '20px',
                            padding: '3rem',
                            
                        }}
                        >
                        <h3 
                            style={{ 
                            fontSize: '1.75rem', 
                            fontWeight: '600',
                            color: colors.dark
                            }}
                        >
                            Formulario de Contacto
                        </h3>
                        <h5 
                            style={{ 
                            fontSize: '1.75rem', 
                            fontWeight: '400',
                            marginBottom: '2rem',
                            color: colors.dark
                            }}
                        >
                            Enviamos tus comentarios o preguntas y te respondemos a la brevedad.
                        </h5>
                        <div class="linea-naranja"></div>
                        </motion.div>
                    </div>
                <div className="col-lg-6">
                    <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8 }}
                    style={{
                        background: colors.light,
                        borderRadius: '20px',
                        padding: '3rem',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                    }}
                    >
                    <p
                        style={{
                        color: colors.primary,
                        }}
                    
                    >Ponte en contacto</p>
                    <h2 
                        style={{ 
                        fontSize: '1.75rem', 
                        fontWeight: '600',
                        marginBottom: '2rem',
                        color: colors.dark
                        }}
                    >
                        Formulario de contacto
                    </h2>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-4">
                        <div className="col-md-6">
                            <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                id="nombre"
                                name="nombre"
                                placeholder="Tu nombre o empresa"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                style={{
                                border: 'none',
                                borderRadius: '10px',
                                background: colors.gray,
                                padding: '1.5rem 1rem'
                                }}
                                required
                            />
                            <label htmlFor="nombre">Tu nombre</label>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-floating">
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                placeholder="Tu email"
                                value={formData.email}
                                onChange={handleInputChange}
                                style={{
                                border: 'none',
                                borderRadius: '10px',
                                background: colors.gray,
                                padding: '1.5rem 1rem'
                                }}
                                required
                            />
                            <label htmlFor="email">Tu email</label>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                id="asunto"
                                name="asunto"
                                placeholder="Asunto"
                                value={formData.asunto}
                                onChange={handleInputChange}
                                style={{
                                border: 'none',
                                borderRadius: '10px',
                                background: colors.gray,
                                padding: '1.5rem 1rem'
                                }}
                                required
                            />
                            <label htmlFor="asunto">Asunto</label>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-floating">
                            <textarea
                                className="form-control"
                                id="mensaje"
                                name="mensaje"
                                placeholder="Tu mensaje"
                                value={formData.mensaje}
                                onChange={handleInputChange}
                                style={{
                                border: 'none',
                                borderRadius: '10px',
                                background: colors.gray,
                                padding: '1.5rem 1rem',
                                height: '150px'
                                }}
                                required
                            ></textarea>
                            <label htmlFor="mensaje">Tu mensaje</label>
                            </div>
                        </div>
                        <div className="col-12">
                            <motion.button
                            type="submit"
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            style={{
                                width: '100%',
                                background: colors.primary,
                                color: colors.light,
                                border: 'none',
                                borderRadius: '10px',
                                padding: '1rem',
                                fontSize: '1.1rem',
                                fontWeight: '500',
                                cursor: 'pointer'
                            }}
                            >
                            {status.submitting ? 'Enviando...' : 'Enviar mensaje'}
                            </motion.button>
                            {status.info.msg && (
                            <div 
                                className={`mt-3 text-center ${status.info.error ? 'text-danger' : 'text-success'}`}
                                role="alert"
                            >
                                {status.info.msg}
                            </div>
                            )}
                        </div>
                        </div>
                    </form>
                    </motion.div>
                </div>
                </div>
            </div>
            </motion.section>

        </MainLayout>
    )
}

export default Servicios;